<template>
  <v-row no-gutters>
    <v-toolbar flat dark color="primary">
      <v-toolbar-title>
        <span class="headline">Новый резерв</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn icon dark @click="cancelProvision">
          <v-icon>{{ icons.close }}</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-form ref="form" v-model="valid">
      <v-card>
        <v-card-text>
          <v-container>
            <v-autocomplete
              clearable
              label="Пункт доставки"
              v-model.trim="provisionModel.pointId"
              :rules="rules.point"
              :items="points"
              item-text="address"
              item-value="pointId"
            ></v-autocomplete>

            <v-autocomplete
              clearable
              required
              label="Производитель"
              v-model.trim="provisionModel.manufacturerId"
              :rules="[(v) => !!v || 'введите производителя']"
              :items="Object.entries(manufacturers)"
              item-text="[1][0].manufacturer"
              item-value="[0]"
            >
            </v-autocomplete>

            <v-autocomplete
              clearable
              label="Наименование"
              v-model.trim="provisionModel.productId"
              :rules="[
                (v) =>
                  !!v ||
                  !!this.provisionModel.manufacturerId ||
                  'введите наименование',
              ]"
              :items="Object.entries(productNames)"
              item-text="[0]"
              item-value="[1][0].productId"
            ></v-autocomplete>

            <v-layout align-center>
              <v-flex>
                <v-menu offset-y transition="scale-transition">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      readonly
                      clearable
                      v-on="on"
                      label="Дата начала"
                      v-model.trim="provisionModel.start"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    color="secondary"
                    v-model.trim="provisionModel.start"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex>
                <v-icon class="mx-1">{{ icons.arrowLeftRight }}</v-icon>
              </v-flex>
              <v-flex>
                <v-menu offset-y transition="scale-transition">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      readonly
                      clearable
                      required
                      v-on="on"
                      label="Дата завершения*"
                      v-model.trim="provisionModel.end"
                      :rules="rules.end"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    color="secondary"
                    v-model.trim="provisionModel.end"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>

            <v-row>
              <v-col>
                <v-text-field
                  clearable
                  label="РОЦ"
                  v-model.trim="provisionModel.price"
                  :rules="[
                    (v) =>
                      !!v ||
                      !!this.provisionModel.quantity ||
                      'введите РОЦ и/или количество',
                  ]"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  clearable
                  label="Количество"
                  v-model.trim="provisionModel.quantity"
                  :disabled="!provisionModel.productId"
                  :rules="[
                    (v) =>
                      !!v ||
                      !!this.provisionModel.price ||
                      'введите количество и/или РОЦ',
                  ]"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
          <small>*указывает на обязательное поле</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined color="primary" @click="cancelProvision"
            >Отмена</v-btn
          >
          <v-btn dark color="primary" @click="saveProvision">Сохранить</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-row>
</template>

<script>
import { mapState, mapActions } from "vuex";

import { Icon } from "@/helpers";
import { groupBy } from "@/helpers";

export default {
  props: {},
  components: {},
  computed: {
    ...mapState({
      points: (state) => state.points.points,
      manufacturersProducts: (state) =>
        state.products.validManufacturersProducts,
      user: (state) => state.users.user,
    }),
    manufacturers: function () {
      return this.provisionModel.productId
        ? groupBy(
            ["manufacturerId"],
            this.manufacturersProducts.filter(
              (i) => i.productId === this.provisionModel.productId
            )
          )
        : groupBy(["manufacturerId"], this.manufacturersProducts);
    },
    productNames: function () {
      return this.provisionModel.manufacturerId
        ? groupBy(
            ["productName"],
            this.manufacturersProducts.filter(
              (i) => i.manufacturerId === this.provisionModel.manufacturerId
            )
          )
        : groupBy(["productName"], this.manufacturersProducts);
    },
  },
  methods: {
    ...mapActions({
      getPoints: "points/GET_POINTS",
      getValidManufacturersProducts:
        "products/GET_VALID_MANUFACTURERS_PRODUCTS",
    }),
    cancelProvision: function () {
      this.$emit("cancel-provision");
      Object.assign(this.provisionModel, this.provisionModelDefault);
    },
    saveProvision: function () {
      this.$refs.form.validate();
      if (this.valid) {
        let currentProvisionModel = Object.assign({}, this.provisionModel);
        this.$emit("save-provision", currentProvisionModel);
        Object.assign(this.provisionModel, this.provisionModelDefault);
      }
    },
    validate: function () {
      this.$refs.form.validate();
    },
  },
  watch: {
    "provisionModel.manufacturerId": "validate",
    "provisionModel.productId": "validate",
    "provisionModel.price": "validate",
    "provisionModel.quantity": "validate",
  },
  data: () => ({
    icons: {
      arrowLeftRight: Icon.arrowLeftRight,
      close: Icon.close,
      plus: Icon.plus,
    },
    valid: true,
    provisionModelDefault: {
      pointId: "",
      manufacturerId: "",
      productId: "",
      start: "",
      end: "",
      price: "",
      quantity: "",
    },
    provisionModel: {
      pointId: "",
      manufacturerId: "",
      productId: "",
      start: "",
      end: "",
      price: "",
      quantity: "",
    },
    rules: {
      end: [(v) => !!v || "обязательное поле"],
    },
  }),
  mounted: async function () {
    await this.getPoints(this.user.userId);
    await this.getValidManufacturersProducts();
  },
};
</script>
